import React from 'react';
import RadioSelect from 'components/pure/utils/form/RadioSelect';
import Loading from 'components/pure/utils/Loading';

export default class SearchFieldSelection extends React.Component {
  render() {
    const {searchFields, selectedField, selectedOption, searchFieldsLoading} = this.props;
    return (
      <div className="search-field-select">
        <ul>
          {searchFieldsLoading && (
            <li className="loading-selections">
              <Loading />
            </li>
          )}
          {!searchFieldsLoading && searchFields.size === 0 && (
            <li className="empty-selections">No search fields configured for your organization</li>
          )}
          {searchFields
            .sortBy(field => field.fieldDefinition.label)
            .map(field => (
              <li key={field.fieldDefinition.value}>
                <RadioSelect
                  label={field.fieldDefinition.label}
                  checked={selectedField === field.fieldDefinition.value}
                  options={field.fieldOptions.sort((x, y) => x.label.localeCompare(y.label))}
                  value={selectedOption}
                  valueChanged={this.props.selectedOptionChange}
                  radioClick={() => this.props.selectedFieldChange(field.fieldDefinition.value)}
                />
              </li>
            ))}
        </ul>
      </div>
    );
  }
}
